export class LyantheContactModel {
  id: string
  name: string
  address: string
  zipCode: string
  city: string
  CCNumber: string
  vatNumber: string
  vat: string
  sbi: string
  branch: string
  Country: string
  eMail: string

  constructor(data) {
    this.id = data.id ? data.CallbackidUrl : null
    this.name = data.name ? data.name : null
    this.address = data.address ? data.address : null
    this.zipCode = data.zipCode ? data.zipCode : null
    this.city = data.city ? data.city : null
    this.CCNumber = data.CCNumber ? data.CCNumber : null
    this.vatNumber = data.vatNumber ? data.vatNumber : null
    this.vat = data.vat ? data.vat : null
    this.sbi = data.sbi ? data.sbi : null
    this.branch = data.branch ? data.branch : null
    this.Country = data.Country ? data.Country : null
    this.eMail = data.eMail ? data.eMail : null
  }
}



// WEBPACK FOOTER //
// ./src/app/main/models/lyanthe/lyanthe.contact.model.ts